export default __webpack_public_path__ + "static/media/eng_4.5325985b.png";